import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import {
  Tooltip,
  CircularProgress,
  Autocomplete,
  TextField,
  Modal,
} from "@mui/material";
import { faCircleInfo, faImages, faLink } from "@fortawesome/free-solid-svg-icons";
import { FaHotel } from "react-icons/fa";
import { FileUploader } from "react-drag-drop-files";
import ImageResolutionTooltip from "../ConfigurationNewHotel/ImageResolutionTooltip";
import { callAPI } from "../../../axios";
import dayjs from "dayjs";
import "./CategoryConfiguration.scss";
import { isValidRole, ScrollToTop } from "../../../utils/utils";
import { MdModeEditOutline } from "react-icons/md";
import DeleteIcon from "@mui/icons-material/Delete";
import CarouselComponent from "./CarouselComponent ";
import CategoryCarousel from "./CategoryCarousel";
import DeletePartnerConfig from "./DeletePartnerConfig";
import BasicModal from "../../core/BaseComponents/Modal";
import DeleteBannerImage from "./DeleteBannerImage";
import DeleteBannerImageCategory from "./DeleteBannerImageCategory";

function CategoryConfiguration(props) {
  const { categoryPopupOpen, categoryId, categoryPopupCloseHandler } = props;

  const isHotelDeletedRef = useRef({
    isHotelDeletedModalData: null,
    userConformationModalData: null,
  });

  const isBannerImaageDeletedRef = useRef({
    isBannerImageDeletedModalData: null,
    deleteBannerConformationModalData: null,
  });

  const serviceTypes = ["WEB_LINK","YOUTUBE_LINK","UPLOAD_PICTURE","NO_CONTENT"];
  const [loader, setLoader] = useState(false);
  const [fileError, setFileError] = useState("");
  const [fileImagesError, setFileImagesError] = useState("");
  const [previewBannerConfigIndex, setPreviewBannerConfigIndex] = useState(0);
  const [editHotelRowUpdate, setEditHotelRowUpdate] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [editHotelSid, setEditHotelSid] = useState("");
  const [upLoadedFilesLength, setUpLoadedFilesLength] = useState(0);
  const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState("");
  const [thumbnailImage, setThumbnailImage] = useState({});
  const [uploadedPictures, setUploadedPictures] = useState([]);
  const [editHotelConfig, setEditHotelConfig] = useState(false);
  const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
  const [listConfigId, setListConfigId] = useState([]);
  const [initialSlide, setInitialSlide] = useState(0);
  const [deleteBannerImagePopUpAPI, setDeleteBannerImagePopUpAPI] =
    useState(false);
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [confirmDeleteHotelRow, setConfirmDeleteHotelRow] = useState("");

  const [file, setFile] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const [files, setFiles] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);

  const [categoryList, setCategoryList] = useState([]);
  const [previousState, setPreviousState] =  useState({
    qrCode: "",
    speacialFeature: ""
  })

  // const [pairs, setPairs] = useState([{ id: 0 }]); // default 1 pair

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    control,
    clearErrors
  } = useForm({
    mode: "onChange",
    defaultValues: {
      opacity : 70,
      features: [{ featureKey: "", featureValue: "" }], // Default 1 pair
      // ... other default values
    }
  });

  const backgroundImageOpacityValues = [60,70,80,90]

  const { fields, append, remove } = useFieldArray({
    control, // from useForm()
    name: "features",
    // defaultValue: [{ featureKey: "", featureValue: "" }] // Default 1 pair
  });

  const textPositionMaster = ["Top Left", "Top Right", "Bottom Left", "Bottom Right", "Centered", "Top Center", "Bottom Center"];

  const textPostionClass = (selectedTextPosition) => {
    if (selectedTextPosition === "Top Left") {
      return 'top-left'
    } else if (selectedTextPosition === "Top Right") {
      return 'top-right'
    } else if (selectedTextPosition === "Centered") {
      return 'center'
    } else if (selectedTextPosition === "Bottom Right") {
      return 'bottom-right'
    }else if (selectedTextPosition === "Top Center") {
      return 'top-center'
    }else if (selectedTextPosition === "Bottom Center") {
      return 'bottom-center'
    }
    else if (selectedTextPosition === "Bottom Left") {
      return 'bottom-left'
    }
  }

  const thumbnailImageGuide = [
    {
      name: "Category Service Background Image",
      files: 1,
      size: "700 KB",
      height: 200,
      width: 500,
      resolution: "72 PPI",
      aspect: "16:09",
      formats: "JPG, JPEG, PNG",
    },
  ];

  const hotelServiceImages = [
    {
      name: "Category Service Image",
      files: 15,
      size: "700 KB",
      height: 1080,
      width: 1920,
      resolution: "72 PPI",
      aspect: "16:09",
      formats: "JPG, JPEG, PNG",
    },
  ];

  //   const textPositionMaster = [
  //     "Top Left",
  //     "Top Right",
  //     "Bottom Left",
  //     "Bottom Right",
  //     "Centered",
  //     "Top Center",
  //     "Bottom Center",
  //   ];

  const BannerPreviewHandler = (configId, index) => {
    setShowPreviewPopUp(true);
    setListConfigId(configId);
    setInitialSlide(index);
  };

  const renderWebLink = (row) => {
    let link;
    if (row?.link) {
      link = (
        <Tooltip title={row?.link}>
          <a
            href={row?.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-black d-block ${
              row?.link?.length > 10 ? "overflow-ellipsis" : ""
            }`}
          >
            {row?.link}
          </a>
        </Tooltip>
      );
    } else if (row?.youtubeLink) {
      link = (
        <Tooltip title={row?.youtubeLink}>
          <a
            href={row?.youtubeLink}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-black d-block ${
              row?.youtubeLink?.length > 10 ? "overflow-ellipsis" : ""
            }`}
          >
            {row?.youtubeLink}
          </a>
        </Tooltip>
      );
    } else if (row?.imageSet?.length) {
      link = (
        <div className="delete-config-images">
          {row?.imageSet?.slice(0, 4).map((url, index) => (
            <div className="me-2" key={url?.id}>
              <img
                src={url?.url}
                alt={url?.id}
                onClick={() => BannerPreviewHandler(row?.id, index)}
              />
            </div>
          ))}
          {row?.imageSet?.length > 4 && (
            <span>
              ...
              <span
                onClick={() => BannerPreviewHandler(row?.id, 0)}
                className="ms-2 cdsn-count"
              >
                +{row?.imageSet?.length - 4}
              </span>
            </span>
          )}
        </div>
      );
    }
    else{
      link = <span>N.A</span>
    }
    return link;
  };

  useEffect(() => {
    if (editHotelConfig) {
      getCategoryById();
      setEditHotelConfig(false);
    }
    ScrollToTop();
    setFileError("");
  }, [editHotelConfig]);

  const renderActionIcon = (row) => {
    return isValidRole("HOTEL_SERVICES_MODIFY") ? (
      <>
        <Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => {
              setEditHotelConfig(true);
              setEditHotelSid(row);
            }}
          />
        </Tooltip>
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deleteHotelConfigPopUpHandler(row);
            }}
          />
        </Tooltip>
      </>
    ) : (
      <>
        <Tooltip title="Don't have permission to edit" arrow>
          <span>
            <MdModeEditOutline className="edit-icon-disable" />
          </span>
        </Tooltip>
        <Tooltip title="Don't have permission to edit" arrow>
          <DeleteIcon className="delete-icon-disable" />
        </Tooltip>
      </>
    );
  };

  const columns = [
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 1,
      row: true,
      renderCell: (row) => (
        <p className="mb-0">
          {dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}
        </p>
      ),
    },
    { field: "categoryName", headerName: "Category Name", flex: 1 },
    {
      field: "bgImageUrl",
      headerName: "Category Thumbnail",
      flex: 1,
      row: true,
      renderCell: (row) => (
        <img src={row?.bgImageUrl} alt={row?.id} className="hero-config-img" />
      ),
      disableSortIcon: true,
    },
    {
      field: "link",
      headerName: "Category Details",
      flex: 1,
      row: true,
      renderCell: renderWebLink,
      disableSortIcon: true,
    },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const onSubmit = (data) => {
    if (fileUrl === "") {
      setFileError("Poster Image is required");
      return;
    }
    if (fileError !== "") {
      return;
    }
    if (data?.type === "UPLOAD_PICTURE") {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        let bytes = (file?.size / 1024).toFixed(2);
        if (bytes > 700) {
          setFileImagesError(`Upload file should be less than 700KB`);
          return;
        }
      }
    }
    const formData = new FormData();
    // let fileUrlText = fileUrls?.map(item => item.text);
    // let fileUrlTextPosition = fileUrls?.map(item => item.textPosition);
    // console.log(typeof fileUrlText)
    // console.log(fileUrlText)
    // formData.append('imageText', fileUrlText);
    // formData.append('textPositions', fileUrlTextPosition);
    let payload = {
      hotelSpecialId: categoryId,
      categoryName: data?.categoryName,
      description: data?.featureDescription,
      featureTitle: data?.featureTitle,
      features: data?.features,
      type: data?.type,
      opacity: data?.opacity,
      qrCode: data?.qrCode,
      link: data?.type==="UPLOAD_PICTURE" || data?.type==="NO_CONTENT"?"":data?.link,
    };
    let method = "POST";
    let url = `/hotel-specials/categories`;
    if (editHotelRowUpdate) {
      payload.imageText = fileUrls?.filter(item => !item.id).map(item => item.text);
      payload.textPositions = fileUrls?.filter(item => !item.id).map(item => item.textPosition);
      let updatedText = JSON.stringify(fileUrls?.filter(item => item.id).map(item => ({ imageId: item.id, text: item.text, textPosition: item.textPosition })));
      // console.log(updatedText)
      payload.existingImageTextRequest = JSON.parse(updatedText)
      // console.log(payload)
      method = "PUT";
      url = `/hotel-specials/categories/${editHotelSid?.id}`;
      if (files.length + upLoadedFilesLength > 15) {
        setFileImagesError(
          `${
            upLoadedFilesLength === 15
              ? "Delete any of image to upload new image"
              : `${upLoadedFilesLength} of 15 images are already uploaded. You can only upload ${
                  15 - upLoadedFilesLength
                } more image${(15 - upLoadedFilesLength) === 1 ? '' : 's'}`
          }`
        );
        return;
      }
      setFileImagesError("");
    } else {
      if (data?.type === "UPLOAD_PICTURE") {
        if (files.length === 0) {
          setFileImagesError("You must upload at least 1 image");
          return;
        } else if (files.length > 15) {
          setFileImagesError("You can only upload up to 15 images");
          return;
        }
      }
      payload.imageText = fileUrls?.map((url)=>url?.text)
      payload.textPositions = fileUrls?.map((url)=>url?.textPosition)
    }
    formData.append(
      "specialCategoryRequest",
      new Blob([JSON.stringify(payload)], { type: "application/json" })
    );
    setFileImagesError("");

    formData.append("bgImage ", file);
    if (data?.type === "UPLOAD_PICTURE") {
      Array.from(files).forEach((file) => {
        formData.append("newImages", file);
      });
    }
    setLoader(true);
    callAPI(url, method, formData)
      .then(function (response) {
        setLoader(false);
        cancelHotelHandler()
        setCreateHotelSuccessMsg(response?.message);
        categoryListApi();
        setUpLoadedFilesLength(0);
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  useEffect(() => {
    if (categoryPopupOpen) {
      categoryListApi();
    }
    // callAPI("/speciality-dropdown", "GET")
    //   .then((response) => {
    //     setServiceTypes(response);
    //   })
    //   .catch((err) => console.warn(err.message));
  }, [categoryPopupOpen]);

  const categoryListApi = () => {
    callAPI(`/hotel-specials/categories/${categoryId}`, "GET")
      .then((response) => {
        setCategoryList(
          response?.map((item) => ({ ...item, menuName: item.categoryName }))
        );
      })
      .catch((err) => console.warn(err.message));
  };

  const getCategoryById = () => {
    setLoader(true);
    callAPI(`/hotel-specials/categories/${editHotelSid?.id}/details`, "GET")
      .then(function (response) {
        setLoader(false);
        const payload = {
          //   hotelSpecialId: response?.hotelSpecialId,
          categoryName: response?.categoryName,
          featureDescription: response?.description,
          featureTitle: response?.featureTitle,
          features: response?.featureSet,
          type: response?.type,
          link: response?.link,
          qrCode: response?.qrCode,
          opacity: response?.opacity?response?.opacity:70
        };
        setPreviousState((prev) => ({
          qrCode: response?.qrCode,
          speacialFeature: response?.featureTitle
        }));
        // setPairs(
        //   response?.featureSet?.map((item, index) => ({ ...item, id: index }))
        // );
        setFileUrl(response?.bgImageUrl);
        setUpLoadedFilesLength(response?.imageSet?.length);
        setFileUrls(response?.imageSet);
        reset(payload);
        setThumbnailImage(response?.bgImageUrl);
        setUploadedPictures(response?.imageSet);
        setEditHotelRowUpdate(true);
        setPreviewBannerConfigIndex(0);
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const deleteLogoHandler = () => {
    setFile("");
    setFileUrl("");
    setFileError("");
  };

  const deleteHotelConfigPopUpHandler = (row) => {
    setDeleteHotelPopUp(true);
    const newModalRefData = {
      isHotelDeletedModalData: {
        row,
      },
      userConformationModalData: null,
    };
    isHotelDeletedRef.current = newModalRefData;
  };

  const handleDeleteBanner = (index) => {
    // Revoke the object URL for the deleted file
    URL.revokeObjectURL(fileUrls[index]);
    // console.log(index)
    // Update the state
    // console.log(files);
    // console.log(fileUrls);
    const newFiles = files.filter((_, i) => i !== index);
    const newFileUrls = fileUrls.filter((_, i) => i !== index);
    setPreviewBannerConfigIndex(index ? index - 1 : 0);
    // console.log(newFiles)
    // console.log(newFileUrls)
    setFiles(newFiles);
    setFileUrls(newFileUrls);
  };

  const uploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setFileError("Upload file should be less than 700KB");
      return;
    }
    setFile(fileList);
    setFileError("");
  };

  const uploadImagesOrDragFileHandler = (fileList) => {
    const selectedFiles = Array.from(fileList);
    setFiles((prev) => [...selectedFiles, ...prev]);
    const urls = [];
    selectedFiles.map((file) =>
      urls.push({
        url: URL.createObjectURL(file),
        delete: true,
      })
    );
    setFileUrls((prev) => [...urls, ...prev]);
    // setFileError('');
  };

  const addPair = () => {
    if (fields.length < 3) {
      append({ featureKey: "", featureValue: "" });
    }
  };
  
  const removePair = (index) => {
    remove(index);
  };

  const resetLayoutHandler = () => {
    reset();
    setFileUrl(thumbnailImage);
    setFileUrls(uploadedPictures);
    setFileError("");
  };

  const handleDeleteBannerAPI = (banner, bannerConfigId) => {
    setDeleteBannerImagePopUpAPI(true);
    const newModalRefData = {
      isBannerImageDeletedModalData: {
        bannerImage: banner,
        bannerConfigId: bannerConfigId,
      },
      deleteBannerConformationModalData: null,
    };
    isBannerImaageDeletedRef.current = newModalRefData;
  };

  const popupCloseHandler = () => {
    setDeleteHotelPopUp(false);
    setDeleteBannerImagePopUpAPI(false);
  };

  const deleteHotelHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteHotelRow === "") {
      return;
    }

    if (
      confirmDeleteHotelRow ===
      `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}`
    ) {
      setConfirmValidate(false);
      const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
      callAPI(`/hotel-specials/categories/${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message;
          const newModalRefData = {
            isHotelDeletedModalData: null,
            userConformationModalData: {
              successMessage,
            },
          };
          isHotelDeletedRef.current = newModalRefData;
          setEditHotelSid({});
          categoryListApi();
        })
        .catch((error) => {
          console.warn(error);
        });
    }
    reset({
      categoryName: "",
      link: "",
      type: "",
      opacity : 70,
      qrCode: ""
    });
    setFileUrl("");
    setFile("");
  };

  const deleteBannerImageHandlerApi = () => {
    const { bannerImage, bannerConfigId } =
      isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData;
    callAPI(
      `/hotel-specials/categories/images/delete?categoryId=${bannerConfigId}&imageId=${bannerImage?.id}`,
      "DELETE"
    )
      .then((response) => {
        let successMessage = response.message;
        const newModalRefData = {
          isBannerImageDeletedModalData: null,
          deleteBannerConformationModalData: {
            successMessage,
          },
        };
        isBannerImaageDeletedRef.current = newModalRefData;
        categoryListApi();
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const cancelHotelHandler = () => {
    reset({
      //   hotelSpecialId: response?.hotelSpecialId,
      categoryName: "",
      featureDescription: "",
      featureTitle: "",
      features: [],
      type: "",
      link: "",
      opacity : 70,
      qrCode: ""
    });
    // setPairs([{ id: 0 }]);
    append({ featureKey: "", featureValue: "" });
    setFileUrl("");
    setFile("");
    setFiles([]);
    setFileUrls([]);
    setEditHotelRowUpdate(false);
    setEditHotelSid("");
    setEditHotelConfig(false);
    setUpLoadedFilesLength(0);
  };

  const categoryModalCloseHandler = () => {
    categoryPopupCloseHandler();
    cancelHotelHandler();
  };

  const handleTextChange = (e, input) => {
    if(input === "text"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, text: e.target.value, textPosition: item?.textPosition?.length > 2 ? item?.textPosition : 'Centered' } : item
        )
      );
    }
    else if (input === "textPosition"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, textPosition: e } : item
        )
      );
    }
    
  }

  const characterCountHelper = () =>{
    if(!watch("qrCode")?.length && !watch("featureTitle")?.length){
      return 740
    }
    else if(watch("qrCode")?.length && !watch("featureTitle")?.length){
      return 550
    }
    else if(watch("featureTitle")?.length){
      return 330
    }
  }

  return (
    <Modal
      open={categoryPopupOpen}
      onClose={categoryModalCloseHandler}
      className="basic-modal"
    >
      <div className={`basic-modal_root col-11 categoryModal p-4`}>
        {/* <div className="partner-logo">
          <span onClick={() => categoryModalCloseHandler()}>X</span>
        </div> */}
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form
          className="row hotel-list-form config-management-form mb-2"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-4">
            <div className="form-group-hotel">
              <div className="floating-label">
                <input
                  id="categoryName"
                  maxLength={20}
                  placeholder=""
                  {...register("categoryName", {
                    required: "Title Required",
                    pattern: {
                      value: /^[^\s].*[^\s]$|^[^\s]$/,
                      message: "Spaces are not allowed at start and end",
                    }
                  })}
                />
                <label htmlFor="categoryName">Title</label>
              </div>
              {errors.categoryName && (
                <small className="required">
                  {errors.categoryName.message}
                </small>
              )}
            </div>
            <div className="form-group-hotel mb-3">
              <div className="floating-label">
                <input
                  id="qrCode"
                  maxLength={50}
                  placeholder=""
                  {...register("qrCode", {
                    onChange: () => {
                      if (previousState?.qrCode?.length === 0) {
                        setValue("featureDescription", "");
                        setPreviousState((prev) => ({
                          ...prev,
                          qrCode: watch("qrCode")
                        }));
                      } else {
                        setPreviousState((prev) => ({
                          ...prev,
                          qrCode: watch("qrCode")
                        }));
                      }
                    },
                    // required: "Service Special Feature Name Required",
                    pattern: {
                      value: /^[^\s].*[^\s]$|^[^\s]$/,
                      message: "Spaces are not allowed at start and end",
                    }
                  })}
                />
                <label htmlFor="qrCode">
                  QR Code*
                </label>
              </div>
              {errors.qrCode && (
                <small className="required">
                  {errors.qrCode.message}
                </small>
              )}
            </div>
            <div className="form-group-hotel">
                <div className="floating-select-label">
                  <Controller
                    name="opacity"
                    control={control}
                    rules={{
                      validate: value =>
                        (value !== undefined && value !== null && value !== '') || 'Please Select Info Box Opacity'
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${field?.value ? 'Mui-focused' : ''}`}
                        // limitTags={2}
                        disablePortal
                        // multiple
                        options={backgroundImageOpacityValues}
                        getOptionLabel={(option) => option.toString()}
                        onChange={(_, newValue) => {
                          field.onChange(newValue);
                        }}
                        value={field?.value || []}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            variant="outlined"
                            label="Info Box Opacity"
                            InputLabelProps={{
                              shrink: false,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </div>
                {errors.opacity && (
                  <small className="required">{errors.opacity?.message}</small>
                )}
              </div>
            <div className="form-group-hotel mb-3">
              <div className="floating-label">
                <input
                  id="featureTitle"
                  maxLength={20}
                  placeholder=""
                  {...register("featureTitle", {
                    onChange: () => {
                      if(watch("featureTitle")===""){
                        setValue("features", [{ featureKey: "", featureValue: "" }])
                        clearErrors("features");
                      }
                      if (previousState?.speacialFeature?.length === 0) {
                        setValue("featureDescription", "");
                        setPreviousState((prev) => ({
                          ...prev,
                          speacialFeature: watch("featureTitle")
                        }));
                      } else {
                        setPreviousState((prev) => ({
                          ...prev,
                          speacialFeature: watch("featureTitle")
                        }));
                      }
                    },
                    // required: "Service Special Feature Name Required",
                    pattern: {
                      value: /^[^\s].*[^\s]$|^[^\s]$/,
                      message: "Spaces are not allowed at start and end",
                    }
                  })}
                />
                <label htmlFor="featureTitle">
                  Service Special Feature Name*
                </label>
              </div>
              {errors.featureTitle && (
                <small className="required">
                  {errors.featureTitle.message}
                </small>
              )}
            </div>
            {watch("featureTitle") && fields.map((field, index) => (
              <div className="d-flex align-items-start mb-1" key={field.id}>
                <div className="form-group-hotel me-2">
                  <div className="floating-label">
                    <input
                      id={`featureKey-${field.id}`}
                      maxLength={15}
                      placeholder=""
                      {...register(`features.${index}.featureKey`, {
                        required: watch("featureTitle") && "Item Name Required",
                        pattern: {
                          value: /^[^\s].*[^\s]$|^[^\s]$/,
                          message: "Spaces are not allowed at start and end",
                        }
                      })}
                    />
                    <label htmlFor={`featureKey-${field.id}`}>Special Item Name</label>
                  </div>
                  {errors.features?.[index]?.featureKey && (
                    <small className="required">
                      {errors.features[index].featureKey.message}
                    </small>
                  )}
                </div>

                <div className="form-group-hotel me-2">
                  <div className="floating-label">
                    <input
                      id={`featureValue-${field.id}`}
                      maxLength={25}
                      placeholder=""
                      {...register(`features.${index}.featureValue`, {
                        required: watch("featureTitle") && "Item Value Required",
                        pattern: {
                          value: /^[^\s].*[^\s]$|^[^\s]$/,
                          message: "Spaces are not allowed at start and end",
                        }
                      })}
                    />
                    <label htmlFor={`featureValue-${field.id}`}>Special Item Value</label>
                  </div>
                  {errors.features?.[index]?.featureValue && (
                    <small className="required">
                      {errors.features[index].featureValue.message}
                    </small>
                  )}
                </div>

                {/* Show add button only on the first row and when less than 3 pairs */}
                {index === 0 && (
                  <Tooltip title={fields?.length>2?"Maximum Limit Reached":""} arrow>
                  <span><button
                    type="button"
                    className={`circle-btn ${fields?.length>2?"btn-disable-permission":"add-btn"}`}
                    onClick={addPair}
                  >
                    +
                  </button>
                  </span>
                  </Tooltip>
                )}

                {/* Show remove button for extra pairs (not the first one) */}
                {index > 0 && (
                  <button
                    type="button"
                    className="circle-btn remove-btn"
                    onClick={() => removePair(index)}
                  >
                    ✖
                  </button>
                )}
              </div>
            ))}

          </div>
          <div className="col-4">
            <div className="form-group-hotel">
              <div className="floating-label categoryText">
                {/* <FaHotel className="new-hotel-icons" /> */}
                <textarea
                  id="featureDescription"
                  maxLength={characterCountHelper()}
                  rows={6}
                  placeholder=""
                  {...register("featureDescription", {
                    required: "Description Required",
                    pattern: {
                      value: /^[^\s].*[^\s]$|^[^\s]$/,
                      message: "Spaces are not allowed at start and end",
                    }
                  })}
                />
                <label htmlFor="featureDescription">{`Description (character count: ${watch("featureDescription")?.length}/${characterCountHelper()})`}</label>
              </div>
              {errors.featureDescription && (
                <small className="required">
                  {errors.featureDescription.message}
                </small>
              )}
            </div>
            <div className="form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="type"
                  control={control}
                  rules={{
                    validate: (value) =>
                      (value !== undefined && value !== null && value !== "") ||
                      "Please Select Category Type",
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${
                        field?.value && field?.value?.length > 0
                          ? "Mui-focused"
                          : ""
                      }`}
                      disablePortal
                      options={serviceTypes}
                      getOptionLabel={(option) =>
                        option.replace("_", " ").toLowerCase()
                      }
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Category Type"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.type && (
                <small className="required">{errors.type?.message}</small>
              )}
            </div>
          </div>
          <div className="col-4">
            <div className="form-group-hotel">
            {fileUrl !== "" ? (
              <div className="partner-logo">
                <img className="categoryImage" src={fileUrl} alt={fileUrl} />
                <span onClick={() => deleteLogoHandler()}>X</span>
              </div>
            ) : (
              <FileUploader
                name="file"
                types={["JPG", "PNG", "JPEG"]}
                handleChange={uploadOrDragFileHandler}
                classes="drag-file file-upload-bg p-0"
                children={
                  <>
                    <FontAwesomeIcon icon={faImages} className="fa-lg" />
                    <p className="drag-text">
                      Drag and drop image or
                      <span> Browse</span>
                      <br />
                      To upload{" "}
                      <span className="Roboto-Bold text-black">
                        Poster Image
                      </span>{" "}
                      here.
                      <ImageResolutionTooltip
                        position="left"
                        data={thumbnailImageGuide}
                      />
                    </p>
                    {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                  </>
                }
              />
            )}
            {fileError && <p className="required">{fileError}</p>}
            </div>
            {watch("type") !== "UPLOAD_PICTURE" && watch("type") !== "NO_CONTENT"  && watch("type") && (
              <div className="form-group-hotel">
                <div className="floating-label">
                  <FontAwesomeIcon icon={faLink} className="new-hotel-icons" />
                  <input
                    id="link"
                    placeholder=""
                    {...register("link", {
                      required: "URL is required",
                      pattern:
                        watch("type") === "WEB_LINK"
                          ? {
                              value:
                                /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{1,}(\S*)$/,
                              message:
                                "URL must start with http://www. or https://www.",
                            }
                          : watch("type") === "YOUTUBE_LINK" && {
                              value:
                                /^(https?:\/\/(www\.)?youtube\.com\/|https?:\/\/youtu\.be\/)/,
                              message:
                                "URL must start with https://www.youtube.com/ or https://youtu.be/",
                            },
                    })}
                  />
                  <label htmlFor="link">URL</label>
                </div>
                {errors.link && (
                  <small className="required">{errors.link.message}</small>
                )}
              </div>
            )}
          </div>
          {watch("type") === "UPLOAD_PICTURE" && (
            <div className="form-group-hotel col-12">
              <p className="banner-title">Gallery Images</p>
              <div className="row mx-0">
                {fileUrls?.length > 0 && (
                  <div className="col-9 upload-img">
                    <img
                      src={fileUrls[previewBannerConfigIndex]?.url}
                      alt={fileUrls[previewBannerConfigIndex]?.url}
                    />
                    <p
                    className={textPostionClass(
                      fileUrls[previewBannerConfigIndex]?.textPosition
                    )}
                  >
                    <label>{fileUrls[previewBannerConfigIndex]?.text}</label>
                  </p>
                  </div>
                )}
                <div
                  className={`${
                    fileUrls.length > 0
                      ? "col-3 file-upload-bg"
                      : "col-12 file-upload"
                  }`}
                >
                  <FileUploader
                    name="file"
                    types={["JPG", "PNG", "JPEG"]}
                    multiple={true}
                    handleChange={uploadImagesOrDragFileHandler}
                    classes="drag-file"
                    children={
                      <>
                        <FontAwesomeIcon icon={faImages} className="fa-lg" />
                        <p className="drag-text">
                          Drag and drop your images here, or
                          <span> Browse</span>
                          <br />
                          To {editHotelRowUpdate ? "Add New" : "Upload"} Gallery Images.
                          <ImageResolutionTooltip
                            position="left"
                            data={hotelServiceImages}
                          />
                        </p>
                        {/* <h6>Max file allowed : 15 {fileError===""&&"and Max File Size: 700 KB"} <br /> Formats Supported : JPG, JPEG and PNG</h6> */}
                      </>
                    }
                  />
                  {fileImagesError && (
                    <p className="required">{fileImagesError}</p>
                  )}
                </div>
                <div className="upload-img_url ps-0">
                  {fileUrls?.map((url, index) => (
                    <div key={index}>
                      <img
                        src={url?.url}
                        alt={url?.url}
                        onClick={() => setPreviewBannerConfigIndex(index)}
                        className={`${
                          fileUrls[previewBannerConfigIndex] === url
                            ? "selected-image"
                            : ""
                        }`}
                      />
                      {url?.delete && (
                        <span onClick={() => handleDeleteBanner(index)}>X</span>
                      )}
                    </div>
                  ))}
                </div>
                {fileUrls?.length > 0 && (
                <div className="mt-3">
                  {fileUrls?.map((url, index) => (
                    <>
                      {fileUrls[previewBannerConfigIndex] === url && (
                        <div className="form-group-hotel d-flex">
                          <div
                            key={index}
                            className="floating-label col-4 me-3"
                          >
                            <input
                              type="text"
                              value={url.text}
                              id={url.id}
                              maxLength={300}
                              placeholder=""
                              onChange={(e) => handleTextChange(e, "text")}
                            />
                            <label>Optional Image Text</label>
                          </div>
                          <div className="floating-select-label col-3">
                            <Controller
                              name="textPosition"
                              control={control}
                              // rules={{
                              //   validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please Select Text Position'
                              // }}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  disableClearable
                                  className={`multiselectlist ${
                                    url?.textPosition &&
                                    url?.textPosition.length > 0
                                      ? "Mui-focused"
                                      : ""
                                  }`}
                                  // limitTags={2}
                                  disablePortal
                                  // multiple
                                  options={textPositionMaster}
                                  getOptionLabel={(option) => option.toString()}
                                  onChange={(_, newValue) => {
                                    field.onChange(newValue);
                                    handleTextChange(newValue, "textPosition");
                                  }}
                                  value={
                                    url.textPosition ? url.textPosition : " "
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      variant="outlined"
                                      label="Select Text Position"
                                      InputLabelProps={{
                                        shrink: false,
                                      }}
                                    />
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              )}
              </div>
            </div>
          )}
          <div className="flex-items-between mt-3">
          <small className="required">* Changing QR code or Special Fetaure will reset Description field.</small>
            <div>
            <Tooltip title={"Click to see Category Create Instructions"} arrow placement="left">
              <a
                href={"https://d305f1yuk1f2xt.cloudfront.net/help/Hotel_Service_Category_Creation_Guide1.pdf"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#913aff",
                  textDecoration: "none",
                }}
            >
              <FontAwesomeIcon icon={faCircleInfo} />
              </a>
            </Tooltip>
              <button
                type="button"
                className="clear-btn me-2 ms-3"
                onClick={cancelHotelHandler}
              >
                {editHotelRowUpdate ? "Cancel" : "Clear All"}
              </button>
              {editHotelRowUpdate && (
                <>
                  <button
                    type="button"
                    className="clear-btn me-2"
                    onClick={resetLayoutHandler}
                  >
                    Reset
                  </button>
                </>
              )}
              <Tooltip title={categoryList?.length>13 && !editHotelRowUpdate ?"Maximum Limit Reached":""} arrow>
                <span>
                <button disabled={categoryList?.length>13 && !editHotelRowUpdate} type="submit" className={`create-btn ${categoryList?.length>13 && !editHotelRowUpdate ?"btn-disable-permission":""}`}>
                {editHotelRowUpdate ? "Update" : "Create"}
              </button>
              </span>
            </Tooltip>
            </div>
          </div>
        </form>
        <TableWrapper
          data={categoryList}
          columns={columns}
          noPagination={true}
          module="partner-config"
        />
        {showPreviewPopUp && (
          <CategoryCarousel
            showPreviewPopUp={showPreviewPopUp}
            editHotelSid={editHotelSid}
            listConfigId={listConfigId}
            setShowPreviewPopUp={setShowPreviewPopUp}
            initialSlide={initialSlide}
            hotelServiceListApi={categoryListApi}
            handleDeleteBannerAPI={handleDeleteBannerAPI}
          />
        )}
        {deleteHotelPopUp && (
          <DeletePartnerConfig
            deleteHotelPopUp={deleteHotelPopUp}
            isHotelDeletedRef={isHotelDeletedRef}
            popupCloseHandler={popupCloseHandler}
            deleteHotelHandler={deleteHotelHandler}
            setConfirmDeleteHotelRow={setConfirmDeleteHotelRow}
            confirmDeleteHotelRow={confirmDeleteHotelRow}
            confirmValidate={confirmValidate}
          />
        )}
        <DeleteBannerImageCategory
          deleteBannerImagePopUp={deleteBannerImagePopUpAPI}
          popupCloseHandler={popupCloseHandler}
          deleteBannerImageHandlerApi={deleteBannerImageHandlerApi}
          isBannerImaageDeletedRef={isBannerImaageDeletedRef}
        />
        <BasicModal
          popupOpen={createHotelSuccessMsg !== ""}
          logo={"/Images/approve-qc.png"}
          bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
          footer={{
            secondaryButton: {
              buttonName: "OK",
              action: () => {
                setCreateHotelSuccessMsg("");
                setEditHotelRowUpdate(false);
                categoryListApi();
              },
              buttonPrimaryCustomCss: "cancel-btn_new",
            },
          }}
        />
      </div>
    </Modal>
  );
}

export default CategoryConfiguration;
